var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { uniqBy } from "lodash";
export default function pagination(_a, apollo, key) {
    var query = _a.query, variables = _a.variables;
    if (key === void 0) { key = Object.keys(apollo.data)[0]; }
    var _b, _c;
    var data = apollo.data;
    // @TODO I think we should be user total here instead of count
    if (((_b = data[key]) === null || _b === void 0 ? void 0 : _b.count) === ((_c = data[key]) === null || _c === void 0 ? void 0 : _c.results.length)) {
        return Promise.resolve(data);
    }
    return apollo.fetchMore({
        query: query,
        variables: __assign(__assign({}, variables), { offset: data[key].results.length }),
        updateQuery: function (previousResult, _a) {
            var _b;
            var fetchMoreResult = _a.fetchMoreResult;
            var oldFeed = previousResult[key].results;
            var newFeed = uniqBy(__spreadArrays(oldFeed, fetchMoreResult[key].results), "uuid");
            var newOffset = newFeed.length;
            return _b = {},
                _b[key] = __assign(__assign({}, fetchMoreResult[key]), { offset: newOffset, results: newFeed }),
                _b;
        }
    });
}
